// import React from "react";
// import { AlertTriangle, Home } from "lucide-react";
// import { Link } from "react-router-dom";

// const NotFoundPage = () => {
//   return (
// <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">      
//       <div className="text-center max-w-lg">
        
//         {/* Icon */}
//         <div className="flex justify-center mb-6">
//           <div className="bg-red-500 p-4 rounded-full">
//             <AlertTriangle className="w-10 h-10 text-white" />
//           </div>
//         </div>

//         {/* 404 Text */}
//         <h1 className="text-7xl font-bold text-white mb-2">404</h1>
        
//         <h2 className="text-2xl font-semibold text-white mb-4">
//           Page Not Found
//         </h2>

//         <p className="text-slate-300 mb-8">
//           The page you are looking for doesn’t exist or has been moved.
//         </p>

//         {/* Button */}
//         <Link
//           to="/"
//           className="inline-flex items-center gap-2 px-6 py-3 bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg transition"
//         >
//           <Home className="w-5 h-5" />
//           Go to Home
//         </Link>

//       </div>
//     </div>
//   );
// };

// export default NotFoundPage;


import React from "react";
import { AlertTriangle, Home } from "lucide-react";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50 px-4">
      <div className="text-center max-w-lg">
        
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 p-4 rounded-full">
            <AlertTriangle className="w-10 h-10 text-red-500" />
          </div>
        </div>

        {/* 404 Text */}
        <h1 className="text-7xl font-bold text-slate-800 mb-2">404</h1>
        
        <h2 className="text-2xl font-semibold text-slate-700 mb-4">
          Page Not Found
        </h2>

        <p className="text-slate-500 mb-8">
          The page you are looking for doesn’t exist or has been moved.
        </p>

        {/* Button */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition shadow-sm"
        >
          <Home className="w-5 h-5" />
          Go to Home
        </Link>

      </div>
    </div>
  );
};

export default NotFoundPage;